import { Qualifier } from './Qualifier';
import AchTransactionTypes from '../AchTransactionTypes';
import { IQualifier } from './IQualifier';

export class AchQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier';

    public static readonly NAME: string = 'ACH/Bill Pay';

    splitCounts = false;

    globalMinimumTransactionCount: number = 0;

    globalMinimumTransactionAmount: number = 0;

    transactionType: string = '';

    minTransactionCountAchCredit: number = 0;

    minTransactionCountAchDebit: number = 0;

    minTransactionCountBillPay: number = 0;

    minTransactionAmountAchCredit: number = 0;

    minTransactionAmountAchDebit: number = 0;

    minTransactionAmountBillPay: number = 0;

    constructor(qual?: IQualifier) {
      super(AchQualifier.CLASS, qual ? qual.id : null);

      if (qual) {
        this.globalMinimumTransactionCount = (qual as any).globalMinimumTransactionCount;
        this.globalMinimumTransactionAmount = (qual as any).globalMinimumTransactionAmount;
        this.splitCounts = (qual as any).splitCounts;
        this.transactionType = (qual as any).transactionType;
        this.minTransactionCountAchCredit = (qual as any).minTransactionCountAchCredit;
        this.minTransactionCountAchDebit = (qual as any).minTransactionCountAchDebit;
        this.minTransactionCountBillPay = (qual as any).minTransactionCountBillPay;
        this.minTransactionAmountAchCredit = (qual as any).minTransactionAmountAchCredit;
        this.minTransactionAmountAchDebit = (qual as any).minTransactionAmountAchDebit;
        this.minTransactionAmountBillPay = (qual as any).minTransactionAmountBillPay;
      }
    }

    getDescription(): string {
      if (this.splitCounts === true) {
        return `${AchTransactionTypes[this.transactionType]} split transactions`;
      }
      return `${this.globalMinimumTransactionCount} ${AchTransactionTypes[this.transactionType]} transaction(s)`;
    }

    clone(): IQualifier {
      const clone = new AchQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default AchQualifier;
